'use strict';

const avatarTokens = (theme) => ({
    avatarBlueBackground: theme.colors.primary.dark,
    avatarGreenBackground: theme.colors.success.dark,
    avatarGreyBackground: theme.palette.grey500,
    avatarOrangeBackground: theme.colors.warning.dark,
    avatarPurpleBackground: theme.palette.purple500,
    avatarRedBackground: theme.colors.danger.dark,
    avatarBlueTextColor: theme.colors.body.textLight,
    avatarGreenTextColor: theme.colors.body.textLight,
    avatarGreyTextColor: theme.colors.body.textLight,
    avatarOrangeTextColor: theme.colors.body.textLight,
    avatarPurpleTextColor: theme.colors.body.textLight,
    avatarRedTextColor: theme.colors.body.textLight,
    avatarSizeS: theme.space.component.y.xl,
    avatarSizeM: theme.space.component.y.xxl,
    avatarSizeL: theme.space.component.y.xxxl,
});

exports.avatarTokens = avatarTokens;
//# sourceMappingURL=avatar.js.map
